import script from "./attendee-property-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./attendee-property-list.vue?vue&type=script&setup=true&lang=ts"

import "./attendee-property-list.vue?vue&type=style&index=0&id=50fc9ed2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50fc9ed2"]])

export default __exports__